import * as Yup from 'yup';

export function getInitialValues(pageData) {
    return {
        name: pageData?.userDetails?.userName,
        companyName: pageData?.userDetails?.companyName,
        email: pageData?.userDetails?.emailId,
        line1: pageData?.userDetails?.address?.address1,
        line2: pageData?.userDetails?.address?.address2,
        city: pageData?.userDetails?.address?.city,
        state: pageData?.userDetails?.address?.state,
        zip: pageData?.userDetails?.address?.zipCode,
    }
}
const VALIDATION_SCHEMA = Yup.object().shape({
});

export { VALIDATION_SCHEMA };